<div class="auth-container">
  <div class="row auth-main">
    <div class="col-xl-5 d-none d-xl-block px-0 left-col">
      <div class="image-wrapper"></div>
    </div>

    <div class="col-sm-7 auth-form-section">
      <div class="form-section">
        <div class="auth-wrapper">
          <h5 class="welcome-msg">REESTABLECER CONTRASEÑA</h5>

          <p class="auth-signup-text text-muted">
            ¿NO RECUERDAS TU CONTRASEÑA? NO TE PREOCUPES, INGRESA EL CORREO
            ELECTRONICO Y EL USUARIO ASOCIADOS A TU CUENTA Y TE ENVIAREMOS UN
            LINK PARA REESTABLECERLA
          </p>

          <form #form="ngForm" class="validate-form">
            <div class="row">
              <!-- USUARIO -->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                  <mat-label>USUARIO</mat-label>
                  <input
                    #usrModel="ngModel"
                    [(ngModel)]="usr"
                    aria-autocomplete="none"
                    autocomplete="nope"
                    matInput
                    name="usr"
                    required
                  />
                  <mat-icon
                    class="material-icons-outlined color-icon p-3"
                    matSuffix
                  >
                    person
                  </mat-icon>
                </mat-form-field>

                <div *ngIf="usrModel.touched && usrModel.hasError('required')" class="custom-error-below">
                  <small class="text-danger">EL USUARIO ES REQUERIDO</small>
                </div>
              </div>

              <!-- CORREO -->
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
                <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                  <mat-label>CORREO ELECTRONICO</mat-label>
                  <input
                    #useremail="ngModel"
                    [(ngModel)]="email"
                    aria-autocomplete="none"
                    autocomplete="nope"
                    email
                    matInput
                    name="user-email"
                    required
                  />
                  <mat-icon
                    class="material-icons-outlined color-icon p-3"
                    matSuffix
                  >
                    mail
                  </mat-icon>
                </mat-form-field>

                <div *ngIf="useremail.touched && useremail.hasError('required')" class="custom-error-below">
                  <small class="text-danger">EL CORREO ELECTRONICO ES REQUERIDO</small>
                </div>

                <div *ngIf="useremail.touched && useremail.hasError('email')" class="custom-error-below">
                  <small class="text-danger">INGRESA UN CORREO ELECTRONICO VALIDO</small>
                </div>
              </div>
            </div>

            <div class="container-auth-form-btn mt-5">
              <button
                (click)="sendResetPasswordEmail()"
                [disabled]="!form.valid"
                class="auth-form-btn"
                color="accent"
                mat-flat-button
                type="button"
              >
                REESTABLECER CONTRASEÑA
              </button>
            </div>

            <div class="w-full p-t-25 text-center">
              <div>
                <a class="txt1" routerLink="/authentication/signin">
                  ACCEDER A LA PLATAFORMA
                </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
